import AnalyticsTracking from "Utils/AnalyticsTracking";

export const trackStayWithDefaultRenewal = ({ location }) => {
  AnalyticsTracking.trackEvent("cta_clicked", {
    label: "stay_with_default_renewal",
    location,
  });
};
